export const getCurrentFormat = settings => {
  const formats = Object.keys(settings);
  const initialSettings = formats.find(format => settings[format] !== null);
  return initialSettings || { format: 'text' };
};
